import {
  Button,
  Input,
  Label,
  Text,
  mergeClasses,
} from "@fluentui/react-components";
import { useNewTeamFormStyles } from "./NewTeamForm.styles";
import { INewTeamFormProps } from "./NewTeamForm.types";

export const NewTeamForm = ({
  teamMembers,
  teamName,
  suggestedTeamName,
  onTeamNameChange,
  onTeamNameReset,
}: INewTeamFormProps): JSX.Element => {
  const styles = useNewTeamFormStyles();
  const isTeamNameEmpty = !teamName.trim();
  const isTeamNameChanged = teamName !== suggestedTeamName;

  return (
    <div className={styles.newTeamCard}>
      <div className={styles.newTeamRow}>
        <Label
          className={mergeClasses(
            styles.newTeamLabel,
            styles.newTeamLabelWithInput,
          )}
        >
          Team name
        </Label>
        <div className={styles.newTeamValue}>
          <Input
            id="new-team-name"
            className={styles.newTeamNameInputRoot}
            input={{ className: styles.newTeamNameInput }}
            size="large"
            value={teamName}
            onChange={(_, data) => onTeamNameChange(data.value)}
            aria-invalid={isTeamNameEmpty}
            aria-describedby="new-team-name-hint"
          />
          <div className={styles.newTeamHintRow}>
            <span
              id="new-team-name-hint"
              role={isTeamNameEmpty ? "alert" : undefined}
              className={mergeClasses(
                styles.newTeamHintText,
                isTeamNameEmpty && styles.newTeamHintError,
              )}
            >
              {isTeamNameEmpty
                ? "Enter a name for the Team."
                : "Suggested from the project code and name. You can edit it."}
            </span>
            {isTeamNameChanged && (
              <Button
                appearance="transparent"
                size="small"
                className={styles.resetButton}
                onClick={onTeamNameReset}
              >
                Reset to suggested
              </Button>
            )}
          </div>
        </div>
      </div>
      <div className={styles.newTeamRow}>
        <Text className={styles.newTeamLabel}>Privacy</Text>
        <div className={styles.newTeamValue}>
          <span className={styles.newTeamValueText}>Private</span>
          <span className={styles.newTeamHint}>
            Only added members can see it
          </span>
        </div>
      </div>
      <div className={styles.newTeamRow}>
        <Text className={styles.newTeamLabel}>Owners</Text>
        <div className={styles.newTeamValue}>
          <span className={styles.newTeamValueText}>You</span>
        </div>
      </div>
      <div className={styles.newTeamRow}>
        <Text className={styles.newTeamLabel}>Members</Text>
        <div className={styles.newTeamValue}>
          <span className={styles.newTeamValueText}>
            {teamMembers.length > 0
              ? teamMembers.map((member) => member.text).join(", ")
              : "No team members selected"}
          </span>
          <span className={styles.newTeamHint}>
            Team members of this Project IQ Workspace will be synced to the new
            Team and will get access to it.
          </span>
        </div>
      </div>
      <Text className={styles.noteText}>
        Creating the Workspace sets up the Team and its SharePoint site
        together, with the default Vault folders.
      </Text>
    </div>
  );
};
